import { render, staticRenderFns } from "./ImprovedSurveyEdit.vue?vue&type=template&id=135e9fdf&scoped=true&"
import script from "./ImprovedSurveyEdit.vue?vue&type=script&lang=js&"
export * from "./ImprovedSurveyEdit.vue?vue&type=script&lang=js&"
import style0 from "./ImprovedSurveyEdit.vue?vue&type=style&index=0&id=135e9fdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135e9fdf",
  null
  
)

export default component.exports